import { useTheme } from 'foundations-theming/utils';
import { createCssVarsFromTheme } from 'foundations-theming/utils/createCssVars';
import { createGlobalStyle } from 'styled-components';
export const APPLIED_CSS_VARS_FLAG = '--css-vars-applied';
export const GlobalCSSVariables = createGlobalStyle(() => {
  const theme = useTheme();
  const cssVars = createCssVarsFromTheme(theme);
  return {
    ':root': Object.assign({}, cssVars, {
      [APPLIED_CSS_VARS_FLAG]: 'true'
    })
  };
});